// Sekme oturumu: tüm sekmeler kapanınca oturum düşer; sayfa yenileme ve ek sekmeler oturumu korur
const KEY = "pas_tab_alive";
const CHANNEL = "pas-tab-session";

export const markTabAlive = () => {
  try { sessionStorage.setItem(KEY, "1"); } catch (e) { console.warn("[tab] işaret yazılamadı", e); }
};
const isAlive = () => { try { return !!sessionStorage.getItem(KEY); } catch { return false; } };

// true → bu sekme yenilendi ya da başka açık (oturumlu) sekme var; false → tüm sekmeler kapanmıştı
export async function tabSessionAlive(waitMs = 400) {
  if (isAlive()) return true;
  if (typeof BroadcastChannel === "undefined") { markTabAlive(); return true; }
  const ch = new BroadcastChannel(CHANNEL);
  const alive = await new Promise((resolve) => {
    const t = setTimeout(() => resolve(false), waitMs);
    ch.onmessage = (e) => { if (e.data === "pong") { clearTimeout(t); resolve(true); } };
    ch.postMessage("ping");
  });
  ch.close();
  if (alive) markTabAlive();
  return alive;
}

// Açık her sekme diğerlerinin "ping"ine yanıt verir (yalnız oturum işareti varsa)
export function listenTabPings() {
  if (typeof BroadcastChannel === "undefined") return () => {};
  const ch = new BroadcastChannel(CHANNEL);
  ch.onmessage = (e) => { if (e.data === "ping" && isAlive()) ch.postMessage("pong"); };
  return () => ch.close();
}
